<div class="py-4 container-fluid public-holiday-page">
  <h4 class="mb-4 public-holiday-title">การตั้งค่า - วันหยุดราชการ</h4>

  <div class="public-holiday-card">
    <div class="public-holiday-card-body">
      <div class="public-holiday-toolbar" [formGroup]="form">
        <div class="public-holiday-filters">
          <div class="public-holiday-filter public-holiday-filter-year">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="public-holiday-select"
              classes="mb-0"
            >
            </app-select>
          </div>

          <div class="public-holiday-filter public-holiday-filter-keyword">
            <app-filter-search-input
              label="ชื่อวันหยุดราชการ"
              formControlName="keyword"
              inputClass="public-holiday-search-input"
              classes="mb-0"
              ariaLabel="ค้นหาชื่อวันหยุดราชการ"
              (searchSubmit)="onSearch()"
            ></app-filter-search-input>
          </div>

        </div>

        <div class="public-holiday-buttons">
          <button
            type="button"
            class="btn btn-outline public-holiday-outline-button"
            [disabled]="isDownloadingTemplate || !canImportForYear"
            (click)="onDownloadTemplate()"
          >
            <img src="assets/media/icons/svg/file-down.svg" class="public-holiday-toolbar-icon" alt="" aria-hidden="true" />
            <span>ดาวน์โหลดแบบฟอร์ม</span>
          </button>

          <button
            type="button"
            class="btn btn-outline public-holiday-outline-button"
            [disabled]="isImporting || !canImportForYear"
            [attr.data-bs-toggle]="canImportForYear ? 'modal' : null"
            [attr.data-bs-target]="canImportForYear ? '#importDataModal' : null"
            (click)="onImport()"
          >
            <img src="assets/media/icons/svg/file-up.svg" class="public-holiday-toolbar-icon" alt="" aria-hidden="true" />
            <span>นำเข้าข้อมูล</span>
          </button>

          <button
            type="button"
            class="btn public-holiday-add-button"
            (click)="onAddHoliday()"
          >
            <img src="assets/media/icons/svg/add-item.svg" class="public-holiday-toolbar-icon" alt="" aria-hidden="true" />
            <span>เพิ่มรายการใหม่</span>
          </button>
        </div>
      </div>

      <ng-template #rowIndexTemplate let-row="row" let-rowIndex="rowIndex">
        {{ row.sequence ?? holidays().offset + rowIndex + 1 }}
      </ng-template>

      <ng-template #tableCellAction let-row="row">
        <div class="public-holiday-actions">
        

          @if (row.canEdit) {
              <button
            type="button"
            class="btn public-holiday-action-button"
            (click)="onEditHoliday(row)"
            aria-label="แก้ไขวันหยุดราชการ"
          >
            <img
              src="assets/media/icons/svg/pencxil.svg"
              class="public-holiday-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
          }
          @if (row.canDelete) {
          <button
            type="button"
            class="btn public-holiday-action-button"
            (click)="onDeleteHoliday(row)"
            aria-label="ลบวันหยุดราชการ"
          >
            <img
              src="assets/media/icons/svg/trush.svg"
              class="public-holiday-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
          }
        </div>
      </ng-template>

      <app-datatable
        [datasource]="holidays()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="10"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="holidays().page"
        [limit]="holidays().limit"
        [total]="holidays().total"
        [totalPage]="holidays().total_page"
        [offset]="holidays().offset"
        [dataLength]="holidays().data.length"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="Public holiday pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>

<app-form-import-new
  [isSaving]="isImporting"
  (saved)="onImportFile($event)"
></app-form-import-new>
<app-confirm-dialog
  #importAcademicHolidaySuccessDialog
  modalId="importAcademicHolidaySuccess"
  icon="success"
  title="นำเข้าข้อมูลสำเร็จ"
  message="นำเข้าข้อมูลวันหยุดราชการเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="importAcademicHolidaySuccessDialog.close()"
></app-confirm-dialog>
<app-form-add-academic-holiday
  (saved)="onAcademicHolidaySaved($event)"
  (saveFailed)="onAcademicHolidaySaveFailed($event)"
></app-form-add-academic-holiday>
<app-confirm-dialog
  #deleteAcademicHolidayConfirmDialog
  modalId="deleteAcademicHolidayConfirm"
  title="ยืนยันการลบรายการ"
  message="คุณต้องการลบรายการนี้ใช่หรือไม่ ?"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="isDeleting"
  (confirmed)="onConfirmDeleteHoliday()"
  (cancelled)="onCancelDeleteHoliday()"
></app-confirm-dialog>
<app-confirm-dialog
  #deleteAcademicHolidaySuccessDialog
  modalId="deleteAcademicHolidaySuccess"
  icon="success"
  title="ลบรายการสำเร็จ"
  message="ลบข้อมูลวันหยุดราชการเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="deleteAcademicHolidaySuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #deleteAcademicHolidayErrorDialog
  modalId="deleteAcademicHolidayError"
  icon="error"
  title="ไม่สามารถลบรายการได้"
  [message]="deleteAcademicHolidayErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="deleteAcademicHolidayErrorDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #createAcademicHolidaySuccessDialog
  modalId="createAcademicHolidaySuccess"
  icon="success"
  title="เพิ่มรายการสำเร็จ"
  message="เพิ่มข้อมูลวันหยุดราชการเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="createAcademicHolidaySuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #createAcademicHolidayErrorDialog
  modalId="createAcademicHolidayError"
  icon="error"
  title="ไม่สามารถเพิ่มรายการได้"
  [message]="createAcademicHolidayErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="createAcademicHolidayErrorDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #editAcademicHolidaySuccessDialog
  modalId="editAcademicHolidaySuccess"
  icon="success"
  title="แก้ไขรายการสำเร็จ"
  message="แก้ไขข้อมูลวันหยุดราชการเรียบร้อยแล้ว"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="editAcademicHolidaySuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
  #editAcademicHolidayErrorDialog
  modalId="editAcademicHolidayError"
  icon="error"
  title="ไม่สามารถแก้ไขรายการได้"
  [message]="editAcademicHolidayErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="editAcademicHolidayErrorDialog.close()"
></app-confirm-dialog>
